/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_components/:component/base_creatives" endpoint.
 * Returns base creatives eligible for a given creative component based on the DSA's liquid support map.
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreatives } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreativesResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreativesResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreatives =
  reactQueryFetcherAdapter(
    decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreatives,
    (
      signal: AbortSignal,
      appGroupId: string,
      dsaId: string,
      component: string
    ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreativesResult> => {
      return fetch(
        `/decisioning_studio_agents/${appGroupId}/${dsaId}/creative_components/${component}/base_creatives`,
        "GET",
        {},
        { signal }
      );
    },
    isGetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreativesResult
  );
